module.exports = __webpack_public_path__ + "img/jackpots.294a3a24.svg";